import { combineReducers } from 'redux';
import { keywordsSetsReducer } from '@rsos/reduxDataStore';
import { psaps } from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoSlice';
import { sinatra } from '@rsos/sinatra';
import { initializationReducer } from './initialization';

export const rootReducer = combineReducers({
  initialization: initializationReducer,
  sinatra,
  psaps,
  keywordSets: keywordsSetsReducer,
});

// Runs on the consolidated admin store now, so the section's state type is the
// full admin state (a superset of the section's own reducers).
export type { AdminState as KeywordManagementState } from '../../../reducers';
